module.exports = __webpack_public_path__ + "img/user-import-example.39f5d8c5.png";